module.exports = __webpack_public_path__ + "img/xgy.8046f030.png";